import { keepPreviousData } from '@tanstack/react-query';
import { GetVoucherPaginatedParameters, useRepositoryQuery } from '@mews-commander/data-access';

export const useGetVoucherTableData = (parameters: GetVoucherPaginatedParameters) =>
    useRepositoryQuery('vouchers', 'getOverviewEntries', parameters, {
        placeholderData: keepPreviousData,
        staleTime: 0,
    });
